"use client";

import { Button } from "@/components/ui/button";
import { useCart } from "@/context";
import { CartItemType } from "@/lib/schema";

export function BuyButton({ item }: { item: CartItemType }) {
  const { addToCart, items } = useCart();
  const currentItem = items.find((c) => c.productId === item.productId);

  return (
    <Button
      disabled={!!currentItem}
      variant="default"
      className="w-full font-bold text-base !py-3 h-12 rounded-xl"
      onClick={() => addToCart(item)}
      suppressHydrationWarning
    >
      {currentItem ? "Сагсалсан" : "Худалдаж авах"}
    </Button>
  );
}
